export const DEFAULT_ERC20_DECIMALS = 18;
